import React from 'react';
import './MScInAccountingAndFinance.css'; // Optional: Create a CSS file for styling

const BAinBusinessManagement = () => {
  return (
    <div className="msc-container" style={{ padding: '20px', maxWidth: '800px', marginTop: '160px',marginLeft:'70px' }}>
      <h1 style={{ textAlign: 'center' }}>📘 Bachelor of Arts in Business Management</h1>

      <section>
        <h2 style={{ textAlign: 'center' }}>Program Overview</h2>
        <p>
          The BA in Business Management at Admas University equips students with the knowledge and skills to become successful leaders and entrepreneurs in today’s competitive global marketplace. This program integrates core business principles with hands-on experience to prepare graduates for roles in management, strategy, and innovation.
        </p>
      </section>

      <section>
        <h2>🎓 Program Objectives</h2>
        <ul>
          <li>To develop a strong foundation in business and management practices.</li>
          <li>To enhance leadership, communication, and decision-making skills.</li>
          <li>To train students in strategic thinking and problem-solving for business success.</li>
          <li>To encourage ethical and socially responsible management approaches.</li>
        </ul>
      </section>

      <section>
        <h2>📚 Core Courses</h2>
        <ul>
          <li>Principles of Management</li>
          <li>Organizational Behavior</li>
          <li>Marketing Management</li>
          <li>Business Communication</li>
          <li>Operations and Project Management</li>
          <li>Strategic Management</li>
          <li>Human Resource Management</li>
          <li>Business Research Methods</li>
        </ul>
      </section>

      <section>
        <h2>🎓 Admission Requirements</h2>
        <ul>
          <li>Completion of the Ethiopian Higher Education Entrance Certificate (Grade 12 national exam).</li>
          <li>TVET Level IV graduates with a COC certificate are eligible via bridging programs.</li>
          <li>Transfer applicants from accredited higher institutions may be considered.</li>
        </ul>
      </section>

      <section>
        <h2>🧭 Career Opportunities</h2>
        <p>
          Graduates can pursue careers as business managers, operations supervisors, marketing officers, HR specialists, entrepreneurs, and consultants in both public and private sectors.
        </p>
      </section>

      <section>
        <h2>🏛️ Why Choose Admas University?</h2>
        <ul>
          <li>Accredited and industry-recognized curriculum tailored to today’s market needs.</li>
          <li>Experienced instructors and practical business training.</li>
          <li>Flexible study options: regular, evening, and weekend classes.</li>
          <li>Campuses across Ethiopia and strong alumni network.</li>
          <li>Focus on innovation, leadership, and entrepreneurial thinking.</li>
        </ul>
      </section>
    </div>
  );
};

export default BAinBusinessManagement;